import usePersistentSetting, {
	PersistentSettingKeys,
} from '@apps/www/src/www/hooks/usePersistentSetting';

export default function useLanguageSetting() {
	const [language, setLanguage] = usePersistentSetting(PersistentSettingKeys.LANGUAGE);

	return [language, setLanguage] as const;
}
